// import { actionTypes } from '../app/modules/Auth/_redux/authRedux';
import { ErrorCodes } from '@/app/data/errorCodes';
import { superAdminAuthActions } from '@/app/modules/Auth/_redux/super-admin/superAdminAuthSlice';
import { removeSuperAdminToken } from '@/app/utils/localstorage';

// export default function setupUserAxios(axios, store) {
//   axios.interceptors.request.use(
//     config => {
//       const {
//         auth: { authToken }
//       } = store.getState();
// import { actionTypes } from '../app/modules/Auth/_redux/authRedux';

export default function setupSuperAdminAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {
        superAdminAuth: { authToken }
      } = store.getState();

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }

      return config;
    },
    err => Promise.reject(err)
  );
  axios.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      if (error && error.response) {
        const { errorCode } = error.response.data;
        if (errorCode === ErrorCodes.TOKEN_EXPIRED) {
          removeSuperAdminToken();
          store.dispatch(superAdminAuthActions.clearSuperAdminToken());
        } else if (errorCode === ErrorCodes.INVALID_TOKEN) {
          removeSuperAdminToken();
          store.dispatch(superAdminAuthActions.clearSuperAdminToken());
        }

        //   const errorResponse = error.response;
        //   if (errorResponse.status === 401) {
        //     store.dispatch({ type: actionTypes.Timeout });
        //     if (errorResponse.data.message !== 'You are not logged in') {
        //       // TODO: hide token expire alert
        //       // store.dispatch({ type: actionTypes.SetErrorMessage, payload: { error: errorResponse.data.message } });
        //     }
        //   } else if (errorResponse.status === 403) {
        //     store.dispatch({ type: actionTypes.Timeout });
        //     //TODO: handle specific cases for 403
        //   }
      }
      return Promise.reject(error);
    }
  );
}
